"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anchorPoint = exports.moduleNum = exports.navFixNum = void 0;
var tool_1 = require("mobile/utils/tool");
var constants_1 = require("./constants");
exports.navFixNum = function (hasTitle, isInApp) {
    var result = 0;
    if (isInApp) {
        result = 0;
    }
    else {
        result = hasTitle ? 5.75 : 2.75;
    }
    return result;
};
exports.moduleNum = function (hasTitle, navFixed, isInApp) {
    var result = 0;
    if (isInApp) {
        result = navFixed ? 3 : 0;
    }
    else {
        result = hasTitle
            ? navFixed
                ? 6 + constants_1.pageFixedHeight
                : 3 + constants_1.pageFixedHeight
            : navFixed
                ? 3 + constants_1.pageFixedHeight
                : constants_1.pageFixedHeight;
    }
    return result;
};
exports.anchorPoint = function (moduleMap, link, hasTitle, navFixed) {
    var found = moduleMap.find(function (ele) { return ele && ele.link === link; });
    if (found.item && found.item.offsetTop) {
        var topValue = exports.moduleNum(hasTitle, navFixed);
        window.scrollTo(0, found.item.offsetTop - tool_1.getPxByRem(topValue));
    }
};
